import { LowDevicesOptions } from "@hakit/core";

export function DummyComponentLowDevicesProps(props: Partial<LowDevicesOptions>) {
  return props;
}
